import { render, staticRenderFns } from "./MagazinePuzzles.vue?vue&type=template&id=1dc9a24a&scoped=true&"
import script from "./MagazinePuzzles.vue?vue&type=script&lang=js&"
export * from "./MagazinePuzzles.vue?vue&type=script&lang=js&"
import style0 from "./MagazinePuzzles.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./MagazinePuzzles.vue?vue&type=style&index=1&id=1dc9a24a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc9a24a",
  null
  
)

export default component.exports